"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  cursor: pointer;\n  color: ", ";\n  text-decoration: underline;\n  border: none;\n  background-color: transparent;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var FakeLink = _styledComponents.default.button.attrs(function (_ref) {
  var className = _ref.className;
  return {
    className: className || 'fake-link'
  };
})(_templateObject(), _Constant.Color.MEDIUM_GREY);

FakeLink.displayName = 'FakeLink';
var _default = FakeLink;
exports.default = _default;